/**
 * Vehicle road worthy check status values
 */
export enum VehicleRoadWorthyCheckStatusEnum {
	/**
	 * Vehicle road worthy check is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle road worthy check is in progress
	 */
	ACTIVE = 'active',
	/**
	 * Vehicle road worthy check is expired
	 */
	EXPIRED = 'expired',
}
